import { createApi } from "@reduxjs/toolkit/query/react";

import { TagType } from "../enums";
import { productApiBaseQuery } from "./productApiBaseQuery";

export const productApi = createApi({
  reducerPath: "productApi",
  baseQuery: productApiBaseQuery({
    // Fill in your own server starting URL here
    baseUrl: window.REACT_APP_PRODUCT_API,
  }),
  endpoints: () => ({}),
  tagTypes: Object.values(TagType),
});
